export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/KG-c0059ac7e8aa487b60e729e06b0a8ebf.png";